var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.958,
    height: 42,
    viewBox: "0 0 43.958 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-355.079 -263.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12310",
    "data-name": "Path 12310",
    d: "M663.917,945.064c-6.935,0-11.419-6.507-11.607-6.784a2.012,2.012,0,0,1,.041-2.314c.2-.271,4.886-6.586,11.566-6.586,6.711,0,11.192,6.356,11.38,6.628a2.012,2.012,0,0,1,.04,2.232C675.159,938.517,670.885,945.064,663.917,945.064Zm-7.318-7.872c1.351,1.484,4.021,3.848,7.319,3.848s5.876-2.379,7.154-3.848c-1.326-1.445-3.967-3.788-7.154-3.788S658,935.732,656.6,937.192Z",
    transform: "translate(-286.845 -640.413)",
    fill: "#ea356f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.845,
    cy: 2.845,
    r: 2.845,
    transform: "translate(374.119 293.83)",
    fill: "#ea356f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12311",
    "data-name": "Path 12311",
    d: "M399.037,281.238,384.43,263.929H362.584a7.2,7.2,0,0,0-5.343,2.407,8.505,8.505,0,0,0-2.162,5.74v37.768a8.355,8.355,0,0,0,2.235,5.757,7.3,7.3,0,0,0,5.328,2.329h28.891a7.2,7.2,0,0,0,5.343-2.406,8.5,8.5,0,0,0,2.162-5.739V281.238ZM389.916,298.7a20.313,20.313,0,0,1-3.491,4.194,16.413,16.413,0,0,1-3.964,2.733,12.373,12.373,0,0,1-5.389,1.265,12.547,12.547,0,0,1-5.393-1.254,17.121,17.121,0,0,1-4.018-2.706,21.093,21.093,0,0,1-3.6-4.15,4.254,4.254,0,0,1,.075-4.587,22.007,22.007,0,0,1,3.665-4.008,17.661,17.661,0,0,1,4-2.617,12.452,12.452,0,0,1,5.267-1.217,12.25,12.25,0,0,1,5.263,1.228,17.025,17.025,0,0,1,3.944,2.644,21.172,21.172,0,0,1,3.562,4.051,4.238,4.238,0,0,1,.075,4.422Zm-1.888-19.648a1.636,1.636,0,0,1-1.569-1.69v-7.778l7.99,9.469Z",
    transform: "translate(0 0)",
    fill: "#ea356f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.27fb778343ea2ce8434205538f6801ad.svg";
export { ForwardRef as ReactComponent };